import { defineAsyncComponent, markRaw } from 'vue';

export const PRODUCT_REVIEW_CARD_TOP_REVIEWS = 'PRODUCT_REVIEW_CARD_TOP_REVIEWS';
export const PRODUCT_REVIEW_CARD_REVIEW_DETAILS = 'PRODUCT_REVIEW_CARD_REVIEW_DETAILS';
export const PRODUCT_REVIEW_CARD_REVIEW_LIST = 'PRODUCT_REVIEW_CARD_REVIEW_LIST';

export const PRODUCT_PAGE_VIEW_MODES = {
    BUY: 'buy',
    RENT: 'rent',
};

export const PRODUCT_REVIEW_CARD_TYPES = [
    PRODUCT_REVIEW_CARD_TOP_REVIEWS,
    PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
    PRODUCT_REVIEW_CARD_REVIEW_LIST,
];

export const productReviewCardTypesMap = {
    [PRODUCT_REVIEW_CARD_TOP_REVIEWS]: {
        type: PRODUCT_REVIEW_CARD_TOP_REVIEWS,
        showLeftColumn: false,
        showFullImage: false,
        showThumbnailImage: false,
        showFullReviewBody: false,
        showActionButton: true,
    },
    [PRODUCT_REVIEW_CARD_REVIEW_DETAILS]: {
        type: PRODUCT_REVIEW_CARD_REVIEW_DETAILS,
        showLeftColumn: true,
        showFullImage: true,
        showThumbnailImage: false,
        showFullReviewBody: true,
        showActionButton: false,
    },
    [PRODUCT_REVIEW_CARD_REVIEW_LIST]: {
        type: PRODUCT_REVIEW_CARD_REVIEW_LIST,
        showLeftColumn: true,
        showFullImage: false,
        showThumbnailImage: true,
        showFullReviewBody: true,
        showActionButton: false,
    },
};

export const MAX_FIT = 3;

export const SIZE_RANGES = {
    petite: {
        min: 0,
        max: 16,
    },
    plus: {
        min: 14,
        max: 40,
    },
    regular: {
        min: 0,
        max: 18,
    },
};

export const DEFAULT_NUM_REVIEWS = 16;
export const DEFAULT_NUM_REVIEWS_IMAGE_ONLY = 5;

export const REVIEWS_CAROUSEL_PAGE_SIZE = 1;

export const PRODUCT_ORDER_STATUSES = {
    PURCHASED: 'PURCHASED',
    CLOSED: 'CLOSED',
};

export const PRODUCT_REVIEW_TYPES = {
    FIT_TECH: 'fitTech',
};

// NU_EXPERIMENT: productSimilarityPdp
// https://urbnit.atlassian.net/browse/TYP-34099
// remove below if necessary when experiment is over
export const PDP_PRODUCT_TRAY_IDS = {
    YOU_MAY_ALSO_LIKE: 'you-may-also-like',
    VISUALLY_SIMILAR: 'visually-similar',
    RECENTLY_VIEWED: 'recently-viewed',
};
export const DEFAULT_NUM_RECOMMENDATION_ITEMS = 15;

export const FILTERED_DEPARTMENTS = [
    'Petite',
    'Plus',
    'Maternity',
    'Vintage',
];

export const NUULY_DEPARTMENT_PLUS = 'Plus';

export const PRODUCT_REVIEW_FILTER_SORT = 'sort';
export const PRODUCT_REVIEW_FILTER_ALL = 'all';

export const PRODUCT_REVIEW_FILTER_BRA_CUP = 'braCup';
export const PRODUCT_REVIEW_FILTER_BRA_BRAND = 'braBand';
export const PRODUCT_REVIEW_FILTER_BRA_SIZE = 'braSize';
export const PRODUCT_REVIEW_FILTER_BODY_TYPE = 'bodyType';
export const PRODUCT_REVIEW_FILTER_HEIGHT = 'height';
export const PRODUCT_REVIEW_FILTER_SIZE = 'size';

// NU_FEATURE: USE_BOX_COLOR_SELECTOR
// https://urbnit.atlassian.net/browse/TYP-27174
// remove this constant when the feature is removed
export const PRODUCT_COLOR_SELECTOR = 'pdpColorSelector';

export const BRA_SIZE = {
    name: PRODUCT_REVIEW_FILTER_BRA_SIZE,
    displayName: 'reviews__braSizeFilterGroup--title',
};

export const ALLOWED_PRODUCT_REVIEW_FILTERS = [
    PRODUCT_REVIEW_FILTER_BRA_CUP,
    PRODUCT_REVIEW_FILTER_BRA_BRAND,
    PRODUCT_REVIEW_FILTER_BODY_TYPE,
    PRODUCT_REVIEW_FILTER_HEIGHT,
    PRODUCT_REVIEW_FILTER_SIZE,
];

export const PRODUCT_REVIEW_FILTER_BRA_SIZES = [
    PRODUCT_REVIEW_FILTER_BRA_CUP,
    PRODUCT_REVIEW_FILTER_BRA_BRAND,
];

export const PRODUCT_REVIEWS_FILTER_SELECTOR_COMPONENT = {
    [PRODUCT_REVIEW_FILTER_BODY_TYPE]: markRaw(
        defineAsyncComponent(() => import(
            /* webpackChunkName: "productReviewsBodyTypeSelector" */
            '~routes/product/components/ProductReviewsBodyTypeSelector.vue'))),
    [PRODUCT_REVIEW_FILTER_HEIGHT]: markRaw(
        defineAsyncComponent(() => import(
            /* webpackChunkName: "productReviewsHeightSelector" */
            '~routes/product/components/ProductReviewsHeightSelector.vue'))),
    [PRODUCT_REVIEW_FILTER_BRA_SIZE]: markRaw(
        defineAsyncComponent(() => import(
            /* webpackChunkName: "productReviewsBraSizeSelector" */
            '~routes/product/components/ProductReviewsBraSizeSelector.vue'))),
    [PRODUCT_REVIEW_FILTER_SIZE]: markRaw(
        defineAsyncComponent(() => import(
            /* webpackChunkName: "productReviewsSizeSelector" */
            '~routes/product/components/ProductReviewsSizeSelector.vue'))),
};

// naming convention used to identify plus size images in Scene7
export const PLUS_SIZE_IDENTIFIER = '_c';
